export default function treeAutoDetectSchema(_children) {
  if (_children.some(__recusivelyCheckNodes)) return 0;
  return -1;
}
function __recusivelyCheckNodes(node) {
  if (['CalendarView', 'Files', 'Filters', 'Item', 'Input', 'Subtree'].includes(node.attributes[0])) return true;
  return node.children.some(__recusivelyCheckNodes);
}
